<vc-menu #menu></vc-menu>

<div class="mobile-header">
  <vc-page-header-logo [hasMenuIcon]="true" (menuClick)="menu.isMobileMenuOpen = true"></vc-page-header-logo>
</div>

<div class="layout-with-menu-content">
  <router-outlet></router-outlet>
</div>
